import styled from "styled-components"

const Grid = styled.div<any>`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  @media (max-width: 1000px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
  ${props =>
    props.smallerMobileRequired &&
    `@media (max-width: 500px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }`}
`

export default Grid
